import styled, { css } from 'styled-components'

import { ResponsiveImage, focusOutline, fromMd } from '@syconium/little-miss-figgy'

import { hashPrefixed } from '../../../../../../lib/utils/color'

const selectedIconButtonStyle = css`
  border: 2px solid ${o => o.theme.color.stroke.neutral.border.interaction.primary.on.background};
`

const defaultIconButtonStyle = css`
  border: 1px solid ${o => o.theme.color.stroke.neutral.border.decoration.on.strong};
`

export const IconButton = styled.button<{
  isSelected: boolean
}>`
  ${o => (o.isSelected ? selectedIconButtonStyle : defaultIconButtonStyle)}

  border-radius: ${o => o.theme.borderRadius.sm};
  height: ${o => o.theme.spacing(13)};
  outline: none;
  padding: 2px;
  width: ${o => o.theme.spacing(13)};

  ${fromMd} {
    height: ${o => o.theme.spacing(16)};
    width: ${o => o.theme.spacing(16)};
  }

  ${focusOutline}
`

export const StyledResponsiveImage = styled(ResponsiveImage)<{
  backgroundColor?: string
}>`
  background: ${o => hashPrefixed(o.backgroundColor)};
  box-sizing: border-box;
  height: 100%;
  object-fit: cover;
  font-family: 'object-fit: cover';
  padding: 2px;
`
